import React from 'react';
import { map, get } from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.span`
  display: inline-block;
  overflow: hidden;
  max-width: 200px;
  white-space: nowrap;
  vertical-align: middle;
  text-overflow: ellipsis;
`;

const PackageItemsPreview = ({ packageItems, ...props }) => (
  <Wrapper {...props}>{map(get('item.name'), packageItems).join(', ')}</Wrapper>
);

PackageItemsPreview.propTypes = {
  packageItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default PackageItemsPreview;
